import React, { useState } from 'react';
import Input from '../input';
import Button from '../button';
import Icon from 'elektra-iconos';
import fetcher from '../../utils/fetcher';
import styles from './login.sass';
import SMS from './sms.png';
import {setCookie} from '../../utils/cookies'

let hundredth = 0;
let isValidatePhone = false;
let messageSendHide;
let messageCountdownHide;
let messageCleanHide;
let seconds = 60;
let time = '';
let serverHour = '';

const Login = () => {
  const [state, setState] = useState({
    employeeStatus: 'CHECK',
    pinconfirmation: '',
    codeConfirmation: false,
    receivedCode: '',
    phoneNumber: '',
    codeBySMS: '',
    resendedCode: false,
    fetching: false,
    error: false,
    employee: '',
    message: '',
    pin: '',
  });

  const [email, setEmail] = useState('')
  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setState({ ...state, fetching: true });
    if (state.employeeStatus === 'CHECK') {
      fetcher(`/employee/check/${state.employee}`,{}, true).then((response) => {
        if (!response.success) {
          return setState({
            ...state,
            error: true,
            fetching: false,
            message: response.message,  
          });
        }
        serverHour = response.data.serverHour;
        const {name, token, maxAge, path} = response.authCookie
        const { hostname } = window.location;
        setCookie(name, token, maxAge, path, hostname);
        return setState({
          ...state,
          employeeStatus: response.data.status || 'CHECK',
          message: response.message,
          error: !response.success,
          fetching: false,
        });
      });
    } else {
      fetcher(
        state.employeeStatus === 'CREATED'
          ? '/employee/activate'
          : '/employee/login',
        {
          method: 'POST',
          body: JSON.stringify({ employee: state.employee, pin: state.pin }),
        }, true
      ).then((response) => {
        if (response.success) {
          setEmail(response.data.email);
          if (response.data.store) {
            setTimeout(() => {
              document.getElementById('formPost').submit();
            }, 500);
            return;
          }
          const phone = response.data.phone ? response.data.phone : '';
          if (phone) {
            validatePhone(phone)
          } else {
            return setState({
              ...state,
              error: false,
              codeConfirmation: true,
              phoneNumber: phone || ''
            });
          }
        } else {
          return setState({
            ...state,
            error: true,
            fetching: false,
            message: response.message,
          });
        }
      });
    }
  };
  const validatePhone = (phone) => {
    if (phone.length === 10) {
      const params = {
        phoneNumber: '52' + phone,
        employee: state.employee
      };
      fetcher(`/employee/sms`, 
        {
          method: 'POST',
          body: JSON.stringify(params),
        }, true
      ).then((response) => {
        if (response.success) {
          setState({
            ...state,
            codeSended: true,
            codeConfirmation: true,
            phoneNumber: phone,
            message: 'Ya se ha enviado el código a: ' + phone ,
            resendedCode: true,
            error: false
          });
          messageSendHide = setTimeout(()=> {
            setState({
              ...state, 
              message:'', 
              resendedCode: false, 
              error: false, 
              codeSended: true,
              codeConfirmation: true,
              phoneNumber: phone,
            });
          }, 3000);
        }
      }).catch(() => {
        setState({
          ...state,
          error: false,
          codeSended: false,
          message: 'message'
        });
      });
    } else {
      return setState({
        ...state,
        error: true,
        phoneNumber: '',
        codeSended: false,
        message: 'Ingresa número de teléfono válido'
      })
    }
    
  }

  const validateCode = () => {
    const params = {
      employee: state.employee,
      code: state.receivedCode
    }
    fetcher(`/employee/validateCode`, 
      {
        method: 'POST',
        body: JSON.stringify(params),
      }, true
    ).then((response) => {
      if (response.isSuccess) {
        setTimeout(() => {
          document.getElementById('formPost').submit();
        }, 500);
      }else{
        setState({
          ...state,
          error: true,
          fetching: true,
          message: response.message
        });
      }
    }).catch((e) => {
      setState({
        ...state,
        error: false,
        fetching: false,
        message: e
      });
    });
  }

  const countdown = () => {
    if ((hundredth === 0) && ( seconds === 0)) {
      isValidatePhone = false;
      seconds = 60;
    } else {
      if (hundredth === 0) {
        --seconds;
        hundredth = 99;
      } else {
        --hundredth;
      }
      time = seconds.toString();
    }
  }

  const handleResendSMS = () => {
    if (state.phoneNumber && !isValidatePhone) {
      isValidatePhone = true;
      seconds = 60;
      setInterval(countdown, 10);
      validatePhone(state.phoneNumber);
      messageCleanHide = setTimeout(()=> {
        isValidatePhone = false;
        setState({
          ...state,
          message:'', 
          error: false
        });
      }, 60000);
    } else {
      if (isValidatePhone) {
        setState({
          ...state,
          message: 'Ya se ha reenviado el código a '
            + state.phoneNumber + ' espera ' + time + ' segundos para volver a enviar',
          resendedCode: true,
          codeSended: true,
          error: false
        });
        messageCountdownHide = setTimeout(()=> {
          setState({
            ...state,
            message:'',
            resendedCode: false,
            codeSended: true,
            error: false
          });
        }, 6000);
      }
    }
  }

  return (
    <div className={styles.login}>
      <form
        id="formPost"
        method="POST"
        action="https://tiendas.elektra.com.mx/Login/ElektraLogin.aspx">
        <input type="hidden" name="userId" value={email} />
      </form>
      <div className={styles.container}>
        <p className={styles.title}>Ingresa</p>
        {serverHour && (  <div className={styles.hour}>Hora Servidor: {serverHour} </div> ) }
        <div className={styles.form}>
          <p className={styles.subtitle}>Captura tu número de empleado</p>
          <form onSubmit={handleSubmit}>
            <div className={styles.formrow}>
              <Input
                type="number"
                name="employee"
                value={state.employee}
                placeholder="Número de empleado"
                condition={!state.error && state.employee.length >= 9}
                onChange={(e) =>
                  setState({ ...state, employee: e.target.value })
                }
              />
            </div>
            {state.employeeStatus !== 'CHECK' && (
              <div className={styles.formrow}>
                <Input
                  name="pin"
                  maxLength="4"
                  type="password"
                  value={state.pin}
                  condition={!state.error && state.pin.length === 4}
                  onChange={(e) => setState({ ...state, pin: e.target.value })}
                  placeholder={
                    state.employeeStatus === 'ACTIVE'
                      ? 'Ingresa tu NIP'
                      : 'Crea un NIP de 4 números'
                  }
                />
              </div>
            )}
            {state.employeeStatus === 'CREATED' && (
              <div className={styles.formrow}>
                <Input
                  maxLength="4"
                  type="password"
                  name="pinconfirmation"
                  value={state.pinconfirmation}
                  placeholder="Confirma tu NIP"
                  onChange={(e) =>
                    setState({ ...state, pinconfirmation: e.target.value })
                  }
                  condition={
                    !state.error &&
                    state.pinconfirmation === state.pin &&
                    state.pinconfirmation.length === 4
                  }
                />
              </div>
            )}
            {state.employeeStatus === 'CREATED' && (
              <div className={styles.formrow}>
                <div className={styles.reqNIP}>
                  <p>
                    El NIP <b>NO</b> debe tener:
                  </p>
                  <br />
                  <p className={styles.reqRule}>
                    <Icon icon="arrowRightSlim" className={styles.reqArrow} />
                    <span>Números consecutivos</span>
                  </p>
                  <p className={styles.reqRule}>
                    <Icon icon="arrowRightSlim" className={styles.reqArrow} />
                    <span>Números repetitivos</span>
                  </p>
                </div>
              </div>
            )}
            {state.codeConfirmation && (
              <div className= {styles.formphone}>
                <div className={(state.phoneNumber && state.codeSended) ? styles.disabledphone : styles.phone}>
                  <Input
                    type="number"
                    name="phoneNumber"
                    disabled={state.codeSended}
                    maxLength="10"
                    value={state.phoneNumber}
                    placeholder="Ingresa tu número de télefono"
                    condition={state.phoneNumber.length === 10}
                    onChange={ (e) => 
                      setState({ ...state, phoneNumber: e.target.value })
                    }
                  />
                </div>
                <div className={isValidatePhone ? styles.disabledimage : styles.image}>
                  <img onClick={handleResendSMS} src={SMS} alt="message"/>
                </div>
              </div>

            )}
            {state.codeSended && (
              <div className={styles.formrow}>
                <Input
                  type="number"
                  name="receivedCode"
                  maxLength="4"
                  value={state.receivedCode}
                  placeholder="Ingresa el código recibido"
                  condition={!state.error && state.receivedCode.length === 4}
                  onChange={(e) =>
                    setState({ ...state, receivedCode: e.target.value })
                  }
                />
              </div>
            )}
            <div className={styles.formrow}>
              {state.error && <p className={styles.error}>{state.message}</p>}
              {state.resendedCode && <p className={styles.message}>{state.message}</p>}
            </div>
            <div className={styles.formrow}>
              Tu usuario es personal e intransferible
            </div>
            {!state.codeConfirmation && (
              <div className={styles.formrow}>
                  <Button type="submit" disabled={state.fetching}>
                    Siguiente
                  </Button>
              </div>
            )}
          </form>
          {!state.codeConfirmation && (
            <Button
              btnType="link"
              onClick={() => {
                setState({ ...state, pin: '', pinconfirmation: '' });
              }}>
              Cancelar
            </Button>
          )}
          {state.codeConfirmation && (
          <div>
            <div className={styles.formrow}>
              <Button type="submit" onClick={ state.codeSended ? validateCode : () => validatePhone(state.phoneNumber) }>
                { state.codeSended ? 'Validar' : 'Enviar' }
              </Button>
            </div>
            <div className={styles.formrow}>
              <Button
                  btnType="link"
                  onClick={() => {
                    clearTimeout(messageSendHide);
                    clearTimeout(messageCountdownHide);
                    clearTimeout(messageCleanHide);
                    isValidatePhone = false;
                    setState({ ...state, 
                      pin: '',
                      pinconfirmation: '',
                      codeBySMS: '',
                      phone: '',
                      fetching: false,
                      codeConfirmation: false,
                      codeSended: false,
                      resendedCode: false,
                      error: false,
                      message:''
                    });
                  }}>
                  Cancelar
                </Button>
            </div>
          </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Login;
